import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Slice, MagentoCustomer } from './types'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false,
  payload: undefined,
  invalidToken: false
}

const slice = createSlice({
  name: 'customer/me',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
      state.invalidToken = false
    },

    success (state, action: PayloadAction<MagentoCustomer>) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
      state.payload = action.payload
    },

    invalidToken (state) {
      state.invalidToken = true
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
      state.payload = initialState.payload
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure, invalidToken } = slice.actions

export function me (): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())
    try {
      const response = await magentoClient.getClient().customer.me()
      const { data } = response || {}
      const { customer } = data || {}

      if (customer) {
        dispatch(success(customer))
      } else {
        dispatch(failure())
      }

      return response
    } catch (e) {
      dispatch(failure())
    }
  }
}

export function validateSessionIsActive (validateSessionIsActiveInterval: number | undefined): PWAThunk {
  return async (dispatch, getState, params) => {
    const invalidateTokenAndSession = () => {
      window.clearInterval(validateSessionIsActiveInterval)
      dispatch(invalidToken())
    }

    const { magentoClient } = params
    try {
      const response = await magentoClient.getClient().customer.getCustomerValidation()
      const { data } = response || {}
      if (!data.customer) {
        invalidateTokenAndSession()
      }
    } catch (e) {
      invalidateTokenAndSession()
    }
  }
}
